export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8576.7e694114.jpg";